export default "__VITE_ASSET__Chds_aKY__"